var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardPaintAi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 105,
    viewBox: "0 0 151 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.086 7.40356H59.3228C53.8477 7.40356 49.4092 11.842 49.4092 17.3171V66.5728C49.4092 72.0478 53.8477 76.4863 59.3228 76.4863H104.086C109.561 76.4863 114 72.0478 114 66.5728V17.3171C114 11.842 109.561 7.40356 104.086 7.40356Z",
    fill: "#FF9E1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.091 16.4802H58.3181V60.1297H105.091V16.4802Z",
    fill: "#FFF7C0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2566 39.0901H87.0719V54.0949C87.0719 56.0086 84.87 57.566 82.1643 57.566C79.4586 57.566 77.2566 56.0086 77.2566 54.0949V39.0901Z",
    fill: "#94D133"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0423 35.1987C86.4205 35.1987 89.9696 31.6495 89.9696 27.2713C89.9696 22.8932 86.4205 19.344 82.0423 19.344C77.6642 19.344 74.115 22.8932 74.115 27.2713C74.115 31.6495 77.6642 35.1987 82.0423 35.1987Z",
    fill: "#9081FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0423 47.7451C86.4205 47.7451 89.9696 44.1959 89.9696 39.8177C89.9696 35.4396 86.4205 31.8904 82.0423 31.8904C77.6642 31.8904 74.115 35.4396 74.115 39.8177C74.115 44.1959 77.6642 47.7451 82.0423 47.7451Z",
    fill: "#9081FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3184 41.4743C92.6966 41.4743 96.2458 37.9251 96.2458 33.547C96.2458 29.1688 92.6966 25.6196 88.3184 25.6196C83.9403 25.6196 80.3911 29.1688 80.3911 33.547C80.3911 37.9251 83.9403 41.4743 88.3184 41.4743Z",
    fill: "#9081FC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7723 41.4743C80.1504 41.4743 83.6996 37.9251 83.6996 33.547C83.6996 29.1688 80.1504 25.6196 75.7723 25.6196C71.3941 25.6196 67.845 29.1688 67.845 33.547C67.845 37.9251 71.3941 41.4743 75.7723 41.4743Z",
    fill: "#9081FC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0423 38.3739C84.7081 38.3739 86.8692 36.2128 86.8692 33.547C86.8692 30.8813 84.7081 28.7202 82.0423 28.7202C79.3765 28.7202 77.2156 30.8813 77.2156 33.547C77.2156 36.2128 79.3765 38.3739 82.0423 38.3739Z",
    fill: "#FFD44D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardPaintAi);
export default __webpack_public_path__ + "static/media/card_paint_ai.d11e2ec34edeede5a6749ec5a5bb4702.svg";
export { ForwardRef as ReactComponent };